// Blog posts data - dynamically loaded from markdown files
// This file reads all markdown files from the posts directory and parses them

// Import all markdown files from the posts directory
const postModules = import.meta.glob("./posts/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
});

// Parse frontmatter manually (simple parser)
function parseFrontmatter(content) {
  const frontmatterRegex = /^---\n([\s\S]*?)\n---\n([\s\S]*)$/;
  const match = content.match(frontmatterRegex);

  if (!match) {
    return { data: {}, content: content };
  }

  const [, frontmatterStr, markdownContent] = match;
  const data = {};

  // Parse each line of frontmatter
  const lines = frontmatterStr.split("\n");
  let currentKey = null;
  let currentValue = "";

  lines.forEach((line) => {
    const keyValueMatch = line.match(/^(\w+):\s*(.*)$/);

    if (keyValueMatch) {
      // Save previous key-value if exists
      if (currentKey) {
        data[currentKey] = parseValue(currentValue);
      }

      currentKey = keyValueMatch[1];
      currentValue = keyValueMatch[2];
    } else if (currentKey) {
      // Multi-line value
      currentValue += "\n" + line;
    }
  });

  // Save last key-value
  if (currentKey) {
    data[currentKey] = parseValue(currentValue);
  }

  return { data, content: markdownContent.trim() };
}

function parseValue(value) {
  value = value.trim();

  // Remove quotes from strings
  if (
    (value.startsWith('"') && value.endsWith('"')) ||
    (value.startsWith("'") && value.endsWith("'"))
  ) {
    value = value.slice(1, -1);
  }

  // Parse arrays
  if (value.startsWith("[") && value.endsWith("]")) {
    const arrayContent = value.slice(1, -1);
    return arrayContent
      .split(",")
      .map((item) => item.trim())
      .map((item) => {
        // Remove quotes from array items
        if (
          (item.startsWith('"') && item.endsWith('"')) ||
          (item.startsWith("'") && item.endsWith("'"))
        ) {
          return item.slice(1, -1);
        }
        return item;
      })
      .filter((item) => item.length > 0);
  }

  return value;
}

// Load and parse all blog posts
export const blogPosts = Object.entries(postModules).map(
  ([filepath, content]) => {
    const { data, content: markdownContent } = parseFrontmatter(content);

    const post = {
      title: data.title || "Untitled",
      slug: data.slug || "",
      excerpt: data.excerpt || "",
      date: data.date || "",
      readTime: data.readTime || "",
      tags: data.tags || [],
      content: markdownContent,
    };

    console.log("Loaded post:", post.slug, post.title);
    return post;
  },
);

console.log("Total blog posts loaded:", blogPosts.length);

// Helper function to get posts sorted by date (newest first)
export const getSortedPosts = () => {
  return [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));
};

// Helper function to get recent posts (default 5)
export const getRecentPosts = (limit = 5) => {
  return getSortedPosts().slice(0, limit);
};

// Helper function to get posts by tag
export const getPostsByTag = (tag) => {
  return getSortedPosts().filter((post) =>
    post.tags.some((t) => t.toLowerCase() === tag.toLowerCase()),
  );
};

// Helper function to get post by slug
export const getPostBySlug = (slug) => {
  return blogPosts.find((post) => post.slug === slug);
};
